export default __webpack_public_path__ + "static/media/Error.9a313cf6.svg";